export default __webpack_public_path__ + "static/media/cancel.1c046c6f.svg";